const vpnPasswordCache = new Map<string, string>()

function key(machineName: string, clientName: string): string {
  return `${machineName.trim()}::${clientName.trim()}`
}

export function rememberVpnPassword(
  machineName: string,
  clientName: string,
  password: string
): void {
  const pw = password.trim()
  if (!pw) return
  vpnPasswordCache.set(key(machineName, clientName), pw)
}

export function getRememberedVpnPassword(
  machineName: string,
  clientName: string
): string | null {
  return vpnPasswordCache.get(key(machineName, clientName)) ?? null
}
